import React from 'react'
import Modal from '../../../../../../../components/Modal'
import * as S from './ModalDeleteBatch.styles'

const ModalDeleteBatch = ({ deleteObject, deleteAction, cancelAction }) => {
  return (
    <Modal
      data-testid='mdb-main'
      show={deleteObject !== undefined}
      title={`Você deseja deletar o lote ${deleteObject?.batchId}?`}
      closeButtonAction={cancelAction}
      body={
        <>
          <S.UL>
            <S.LI>
              <S.ListItem label="Lote ID" description={deleteObject?.batchId} />
            </S.LI>
            <S.LI>
              <S.ListItem
                label="Código de Barras"
                description={deleteObject?.barcode}
              />
            </S.LI>
            <S.LI>
              <S.ListItem
                label="Descrição"
                description={deleteObject?.description}
              />
            </S.LI>
            <S.LI>
              <S.ListItem
                label="Validade"
                description={deleteObject?.expirationDate?.format('DD/MM/YYYY')}
              />
            </S.LI>
            <S.LI>
              <S.ListItem
                label="Quantidade de Avarias"
                description={deleteObject?.damageQuantity}
              />
            </S.LI>
            <S.LI>
              <S.ListItem label="Total" description={deleteObject?.total} />
            </S.LI>
          </S.UL>

          <S.ButtonWrapper>
            <S.DeleteButton onClick={deleteAction}>Sim</S.DeleteButton>
            <S.CancelButton onClick={cancelAction}>Não</S.CancelButton>
          </S.ButtonWrapper>
        </>
      }
    />
  )
}

export default ModalDeleteBatch
